import { CheckMarkIcon, EditIcon2 } from '@assets/icons';
import { CloseIcon } from '@chakra-ui/icons';
import { Box, Button, Flex, IconButton, Input, Text } from '@chakra-ui/react';
import { usePieceStore } from '@pages/UploadMappingV2/hooks/state/useAddProductSatuan';

function ActionHead({ allValue }) {
    const { piece, setCode, setTempCode, setIsEditing, setEditPiece } = usePieceStore();

    const handleEdit = () => {
        setEditPiece(allValue);
    };

    const handleAddCode = () => {
        setCode(piece.tempCode);
    };

    const handleCancel = () => {
        setCode('');
        setTempCode('');
        setIsEditing(false);
    };

    return !piece.code.trim() ? (
        <Flex gap={'8px'}>
            <IconButton maxW={'30px'} size={'sm'} onClick={handleAddCode}>
                <Box>
                    <CheckMarkIcon color="#fff" size={18} />
                </Box>
            </IconButton>
            <IconButton maxW={'30px'} size={'sm'} variant={'outline'} onClick={handleCancel}>
                <CloseIcon fontSize={'10px'} />
            </IconButton>
        </Flex>
    ) : (
        <Button variant={'unstyled'} onClick={handleEdit} color={'sagitarius.500'} w={'full'} justifyContent={'start'}>
            <EditIcon2 size={18} />
            Edit
        </Button>
    );
}

function CodeCell({ value }) {
    const { piece, setTempCode, isEditing, errors } = usePieceStore();

    return !!piece.code.trim() || isEditing ? (
        <Box>
            <Text>{value}</Text>
        </Box>
    ) : (
        <Box>
            <Input
                placeholder="Tuliskan kode produk"
                value={piece.tempCode ?? ''}
                onChange={(e) => setTempCode(e.target.value)}
                isInvalid={errors.code}
            />
            <Text fontSize={'10px'} mt={'4px'} color={'danger.500'}>
                {errors.code}
            </Text>
        </Box>
    );
}

export const tableHeadListsProductSatuan = [
    {
        key: 'brand',
        title: 'Brand',
        isCanSort: true,
        width: '120px',
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'name',
        title: 'Produk Paragon',
        width: '420px',
        isCanSort: true,
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'barcode',
        title: 'Kode Produk Paragon',
        width: '230px',
        isCanSort: true,
        tableDataList: ({ value }) => {
            return (
                <Box>
                    <Text>{value}</Text>
                </Box>
            );
        },
    },
    {
        key: 'code',
        title: 'Kode Produk di Toko',
        width: '260px',
        isCanSort: true,
        tableDataList: ({ value }) => {
            return <CodeCell value={value} />;
        },
    },
    {
        key: 'action',
        title: 'Action',
        width: '30px',
        align: 'right',
        tableDataList: ({ allValue }) => {
            return <ActionHead allValue={allValue} />;
        },
    },
];
